"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const text_styles_1 = require("@/components/common/text/text.styles");
require("@/components/indicators/list-marker/list-marker");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let TextList = class TextList extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        // 인라인 code처럼 마크업이 필요한 항목은 템플릿으로 넘긴다.
        this.texts = [];
        this.variant = 'check';
    }
    render() {
        const items = this.renderItems();
        if (this.variant === 'number') {
            return (0, lit_1.html) `
        <ol class="list">
          ${items}
        </ol>
      `;
        }
        return (0, lit_1.html) `
      <ul class="list">
        ${items}
      </ul>
    `;
    }
    renderItems() {
        return this.texts.map((text, index) => this.renderItem(text, index));
    }
    renderItem(text, index) {
        return (0, lit_1.html) `
      <li>
        <mm-list-marker variant=${this.variant} value=${index + 1}></mm-list-marker>
        <span>${text}</span>
      </li>
    `;
    }
};
TextList.styles = [
    shared_styles_1.resetStyles,
    text_styles_1.textStyles,
    (0, lit_1.css) `
      .list {
        display: flex;
        flex-direction: column;
        gap: var(--space-2);
      }

      .list li {
        display: flex;
        align-items: flex-start;
        gap: var(--space-2);
        list-style: none;
      }

      /* 마커는 항목 첫 줄의 글자 가운데에 맞춘다. */
      .list li mm-list-marker {
        margin-top: var(--space-1);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], TextList.prototype, "texts", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextList.prototype, "variant", void 0);
TextList = __decorate([
    (0, decorators_js_1.customElement)('mm-text-list')
], TextList);
exports.TextList = TextList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC1saXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGV4dC1saXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFnRTtBQUNoRSxxREFBMkQ7QUFJM0Qsc0VBQWlFO0FBQ2pFLDJEQUF3RDtBQUN4RCwrREFBeUQ7QUFHbEQsSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUFBakM7O1FBd0JMLHFDQUFxQztRQUNMLFVBQUssR0FBbUMsRUFBRSxDQUFBO1FBQzlDLFlBQU8sR0FBc0IsT0FBTyxDQUFBO0lBZ0NsRSxDQUFDO0lBOUJDLE1BQU07UUFDSixNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7UUFFaEMsSUFBSSxJQUFJLENBQUMsT0FBTyxLQUFLLFFBQVEsRUFBRTtZQUM3QixPQUFPLElBQUEsVUFBSSxFQUFBOztZQUVMLEtBQUs7O09BRVYsQ0FBQTtTQUNGO1FBRUQsT0FBTyxJQUFBLFVBQUksRUFBQTs7VUFFTCxLQUFLOztLQUVWLENBQUE7SUFDSCxDQUFDO0lBRU8sV0FBVztRQUNqQixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQTtJQUN0RSxDQUFDO0lBRU8sVUFBVSxDQUFDLElBQTZCLEVBQUUsS0FBYTtRQUM3RCxPQUFPLElBQUEsVUFBSSxFQUFBOztrQ0FFbUIsSUFBSSxDQUFDLE9BQU8sVUFBVSxLQUFLLEdBQUcsQ0FBQztnQkFDakQsSUFBSTs7S0FFZixDQUFBO0lBQ0gsQ0FBQzs7QUF4RE0sZUFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCx3QkFBVTtJQUNWLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7S0FrQkY7Q0FDRixDQUFBO0FBRStCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQzt1Q0FBMkM7QUFDOUM7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3lDQUFxQztBQTFCckQsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFFBQVEsQ0EwRHBCO0FBMURZLDRCQUFRIn0=